import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { tabsClasses } from "@mui/material/Tabs";
import { useNavigate } from "react-router-dom";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import KfinBranches from "./KfinBranches/KfinBranches";
import BranchLocator from "./BranchLocator/BranchLocator";
import ReachOutBanner from "./ReachOutBanner/ReachOutBanner";
import CompanyDetails from "./CompanyDetails/CompanyDetails";
import KfinGraph from "./KfinGraph/KfinGraph";
// import NonPointSalesBranch from "./NonPointSalesBranches/NonPointSalesBranch";
// import NonPointSalesBranchLocator from "./NonPointSalesBranchLocator/NonPointSalesBranchLocator"

function ReachOut() {
    const [value, setValue] = React.useState(1);
    const [pathname, setPathName] = useState('');
    useEffect(() => {
        const pathname = window.location.pathname.replace(/([a-z])([A-Z])/g, '$1 $2');
        const lastSegment = pathname.slice(pathname.lastIndexOf('/') + 1);
        const CategoryIdUrlid = lastSegment;
        setPathName(CategoryIdUrlid);
    })
    const arrayOfTabsObj = [
        { name: "Our Branches", id: 1 },
        { name: "KFin Branches", id: 2 },
        // {name : "Non-Point of Sale Branches", id:4},
        { name: "Company Details", id: 3 },

    ];
    const navigate = useNavigate();
    const handleChange = (event, newValue) => {
        setValue(newValue);
        const selectedTab = arrayOfTabsObj.find(tab => tab.id === newValue);
        navigate(`/Reach-Us/${selectedTab.name.replace(/\s+/g, '')}`);

    };
    useEffect(() => {
        var para = window.location.pathname.toLocaleLowerCase().split('/')[2];
        if (para === "corporateoffice") setValue(1)
        if (para === "kfinbranches") setValue(2)
        if (para === "companydetails") setValue(3)
        // if (para === "nonpointsalesbranch") setValue(4)
    }, []);
    function capitalizeWords(str) {
        return str.replace(/\b\w/g, (match) => match.toUpperCase());
    }
    return (
        <>
            <ReachOutBanner id={value} />
            <main id="main-content" tabIndex="-1">
            <section className="Nav-detail about-detail reachout">
                <Container>
                    <Row>
                        <Col>
                        <nav aria-label="Breadcrumb">
                            <ol className="navigator-arrow">
                                <li><a href="/" aria-label="Home"><i class="fa fa-home" aria-hidden="true"></i></a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                                <li><a href="/Reach-Us"><i>Reach Us</i></a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                                {/* <li>Calculator</li><i class="fa fa-angle-right" aria-hidden="true"></i> */}
                                {window.location.pathname != "/Reach-Us" ? <li>{capitalizeWords(pathname.replace("-", " "))}</li> : 'Our Branches'}
                            </ol>
                        </nav>
                        </Col>
                    </Row>
                </Container>

                <Box>
                    <TabContext value={value}>
                        <Container className="reach-us">
                            <Row>
                                <Col sm={12}>
                                    <Box sx={{ width: "100%" }}

                                    >
                                        <TabList
                                            onChange={handleChange}
                                            variant="scrollable"
                                            sx={{
                                                [`& .${tabsClasses.scrollButtons}`]: {
                                                    "&.Mui-disabled": { opacity: 0.3 },
                                                },
                                            }}
                                            scrollButtons="auto"
                                        >
                                            {arrayOfTabsObj.map((item) => (
                                                <Tab className={item.id == 3 ? "width185" : "width125"} label={item.name} value={item.id} disableFocusRipple></Tab>
                                            ))}
                                        </TabList>
                                    </Box>
                                    <TabPanel value={1}>
                                        <BranchLocator></BranchLocator>
                                    </TabPanel>
                                    <TabPanel value={2}>
                                        <KfinBranches></KfinBranches>
                                    </TabPanel>
                                    <TabPanel value={3}>
                                        <CompanyDetails />
                                    </TabPanel>
                                     {/* <TabPanel value={4}>
                                         <NonPointSalesBranchLocator/>
                                    </TabPanel> */}
                                </Col>
                            </Row>
                        </Container>
                    </TabContext>
                </Box>
            </section>
            </main>

        </>
    )
}

export default ReachOut